import {useState} from 'react'
// import { SendGuiDataEvents } from '../commonScript';
import {Tabs,Dailer,ContactsList,Recent,TabConatiner, Header, Loader} from "./index"
import { useCallContext } from '../callContext/callContext';
import { useMainContext } from '../callContext/MainContext';
const Calls = () => {
  const {language}=useMainContext();
  const [currentTab,setCurrentTab]=useState(<Dailer/>)
  const {callLoader,setCallLoader}=useCallContext();
  // useEffect(()=>
  // {
  //   let guiDataEvent = {};
  //   guiDataEvent['page'] = "calls";
  //   guiDataEvent['event_name'] = "page_view";
  //   SendGuiDataEvents(guiDataEvent); 
  // },[]);

  const tabs = [  
    {id: 1, tabName:
      {
        en: "Dailer",
        fr:"Composeur"
    }, comp: <Dailer/> },  
    {id: 2,tabName: 
      {
      en:"Contacts",
      fr:"Contacts"
      },comp: <ContactsList />},
    {id: 3,tabName: 
      {
        en:"Recent",
        fr:"Récent"
      },comp: <Recent />},
  ];
  const [tabShowing, setTabShowing] = useState(tabs?.[0]?.tabName?.[language]);
  if(callLoader) return <Loader/>
  return (
    <div>
      <Header/>
      <div className='fixed top-16 z-[3000] w-full'>
      <Tabs currentTab={currentTab}
      tabShowing={tabShowing} setCurrentTab={setCurrentTab}
      setTabShowing={setTabShowing}
      allTabs={tabs}/>
      </div>
      <div className='absolute top-28 w-full max-w-[500px]'>
     {currentTab}
      </div>
    </div>
  )
}

export default Calls